import dayjs from 'dayjs';
import ka from 'dayjs/locale/ka';
import 'dayjs/locale/ru.js';
import 'dayjs/locale/uk.js';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import relativeTime from 'dayjs/plugin/relativeTime';
import { AppLangCode } from '@libs/types';
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(relativeTime);
dayjs.locale(AppLangCode.KA, {
    ...ka,
    relativeTime: {
        ...ka.relativeTime,
        future: '%s შემდეგ',
        past: '%s',
        s: '1 წამის წინ',
        m: '1 წუთის წინ',
        mm: '%d წუთის წინ',
        h: '1 საათის წინ',
        hh: '%d საათის წინ',
        d: 'დღეს',
        dd: '%d დღის წინ',
        M: '1 თვის წინ',
        MM: '%d თვის წინ',
        y: '1 წლის წინ',
        yy: '%d წლის წინ',
    },
});
export const WEEKEND_DATE_NUMBERS = [0, 6]; // 0 = Sunday, 6 = Saturday
export const BANK_WORKING_HOURS_DATE = dayjs().hour(17).minute(0);
export const DEFAULT_FORMAT = 'ddd MMM DD YYYY';
export const getCurrentDate = () => dayjs();
export const getDateDifferenceInSeconds = (firstDate, secondDate) => {
    return getDateDifference(firstDate, secondDate) / 1000;
};
export const getDateDifferenceInDays = (firstDate, secondDate) => {
    return getDateDifference(firstDate, secondDate) / 86400000;
};
export const clearDateUnit = (initialDate = getCurrentDate(), unit = 'second') => {
    return initialDate.startOf(unit);
};
export const getDate = (time, format, strict) => dayjs(time, format, strict);
// usage example: getDateFromString('23.12.1997', '.');
export const getDateFromString = (dateString, separator) => {
    const splittedDateStr = dateString.split(separator);
    if (splittedDateStr.length !== 3)
        return {
            isValid: false,
            date: null,
        }; // day, month, year
    const [day, month, year] = splittedDateStr;
    const yearToApply = year.length === 4 ? year : '20' + year;
    const date = new Date(+yearToApply, +month - 1, +day);
    const dateValid = isDateValid(date);
    return {
        isValid: dateValid,
        date: getNativeDateObject(getDate(date)),
    };
};
export const isDateValid = (date) => getDate(date).isValid();
export const isDateFormatValid = (dateFormat, format) => getDate(dateFormat, format).isValid();
export const getDateDifference = (firstDate, secondDate, unit) => {
    return getDate(firstDate).diff(getDate(secondDate), unit);
};
export const formatDate = (format = DEFAULT_FORMAT, time = getCurrentDate()) => {
    const date = getDate(time);
    if (localStorage.getItem('language') === 'ua') {
        return date.locale('uk').format(format);
    }
    return date.locale(localStorage.getItem('language') || 'en').format(format);
};
export const formatDateUtc = (format = DEFAULT_FORMAT, time = getCurrentDate()) => {
    const date = getDate(time).utc();
    if (localStorage.getItem('language') === 'ua') {
        return date.locale('uk').format(format);
    }
    return date.locale(localStorage.getItem('language') || 'en').format(format);
};
export const getNativeDateObject = (date) => dayjs(date).toDate();
export const getMilliseconds = (date) => {
    return getDate(date).valueOf();
};
export const isDateBefore = (firstDate, secondDate) => getDate(firstDate).isBefore(secondDate);
export const addDays = (date, days) => {
    const addedDays = dayjs(date).subtract(days, 'days');
    return getNativeDateObject(addedDays);
};
export const reduceDays = (date, days) => {
    const reducedDay = dayjs(date).subtract(days, 'day');
    return reducedDay;
};
export const setTime = (date, time) => {
    return dayjs(formatDate('YYYY/MM/DD', dayjs(date)) + ` ${time}`);
};
export const getUtcDate = (date) => {
    const formattedDate = dayjs(date);
    const utc = formattedDate.utcOffset() / 60;
    return formattedDate.add(utc, 'hour').toString();
};
export const getDateDifferenceFromCurrentDate = (dateUnit, date) => {
    const targetDate = dayjs(date);
    const currentDate = getCurrentDate();
    return targetDate.diff(currentDate, dateUnit);
};
export const getIsWorkingHours = () => {
    const nowDate = getGeorgianTime();
    const isWorkingDay = !WEEKEND_DATE_NUMBERS.includes(nowDate.day());
    if (!isWorkingDay)
        return false;
    const workingHoursFinishDate = BANK_WORKING_HOURS_DATE;
    const diff = getDateDifference(workingHoursFinishDate, nowDate, 'minute');
    return diff >= 60;
};
export const getTimeAgo = (date, lang = AppLangCode.EN) => {
    return getDate(date).locale(lang).fromNow();
};
export const getGeorgianTime = () => dayjs().tz('Asia/Tbilisi');
//# sourceMappingURL=date.js.map